import Yup from '../../../yup';
import {SEND_PROVIDERS} from '../../../constants';

export const sendProviderParamsSchema = Yup.object().when('sendProvider', {
    is: SEND_PROVIDERS.MAPP,
    then: Yup.object().shape({
        invitationEmailMessageId: Yup.string(),
        reminderEmailMessageId: Yup.string(),
        invitationSMSMessageId: Yup.string(),
        reminderSMSMessageId: Yup.string(),
    }),
    otherwise: Yup.object().strip(),
});
